import React from 'react';
// import { Navigate, useParams } from "react-router-dom";

// import {
//   Grid, 
//   Button, 
// } from "@mui/material";
// import { 
//   Skill, 
// } from "../../models";
// import { 
//   ABILITY_SCORES,
// } from "../../models/Constants";
// import { ModelBase, PlayerObject } from '../../../../models';
// import { AbilityScoreType } from '../../models/Types';

// import API from "../../utilities/system_api";
// import DataUtilities from '../../utilities/common_utilities';

// import ModelBaseInput from "../../components/ModelBaseInput";

// import SelectStringBox from "../../../../components/input/selects/SelectStringBox";
// import LoadingBox from '../../../../components/input/LoadingBox';

// const api = API.getInstance();
// const common_util = DataUtilities.getInstance();

export default function SkillEdit() {
  // const { id } = useParams();
  // const [loading, setLoading] = useState(false);
  // const [fetched, setFetched] = useState(false);
  // const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  // const [navigateTo, setNavigateTo] = useState<string | null>(null);
  // const [obj, setObj] = useState<Skill>(api.working_on_sb === null ? new Skill() : new Skill({ source_books: [{ id: api.working_on_sb._id, type: api.working_on_sb.source_book_type, third_party: api.working_on_sb.third_party }] }));
  // const [change_time, setChangeTime] = useState(0);
  
  // const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  // useEffect(() => {
  //   if (!fetched) {
  //     load();
  //   }
  // });
    
  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);

  // const load = () => {
  //   setFetched(true);
  //   if (id && id !== "") {
  //     setLoading(true);
  //     const onComplete = (res: PlayerObject[] | ModelBase[]) => {
  //       if (res.length === 1 && res[0] instanceof Skill) {
  //         setObj(res[0].clone());
  //         setChangeTime(common_util.get_time_number());
  //       }
  //       setLoading(false);
  //     };
  //     const onProgress = () => {};
  //     api.getObjectsWithCallbacks({ 
  //       data_type: "skill", filter: { _id: id },
  //       onComplete, onProgress 
  //     });
  //   }
  // }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("skill", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/skill");
  //     });
  //   }
  // }

  // const height = window.innerHeight - 105;
  // if (!fetched || loading) {
  //   return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  // } else if (navigateTo !== null) {
  //   return <Navigate to={navigateTo} />;
  // } else { 
  //   const formHeight = window.innerHeight - (window.innerWidth > 600 ? 220 : 220);
  //   return (
  //     <div style={{ height }}>
  //       <Grid container spacing={0} direction="column">
  //         <Grid item 
  //           style={{ 
  //             height: `${formHeight}px`, 
  //             overflowY: "scroll", 
  //             overflowX: "hidden" 
  //           }}>
  //           <Grid container spacing={0} direction="column">
  //             <ModelBaseInput 
  //               obj={obj}
  //               disabled={disabled}
  //               change_time={change_time}
  //               onChange={(changed: ModelBase) => {
  //                 if (changed instanceof Skill) {
  //                   const new_obj = obj;
  //                   new_obj.copy(changed);
  //                   setObj(new_obj);
  //                   setChangeTime(common_util.get_time_number());
  //                 }
  //               }}
  //             />
  //             <Grid item>
  //               <SelectStringBox 
  //                 value={obj.use_ability_score} 
  //                 options={ABILITY_SCORES}
  //                 name="Use Ability Score"
  //                 disabled={disabled}
  //                 onChange={(value: AbilityScoreType) => {
  //                   const new_obj = obj;
  //                   new_obj.use_ability_score = value;
  //                   setObj(new_obj);
  //                   setChangeTime(common_util.get_time_number());
  //                 }}
  //               />
  //             </Grid>
  //           </Grid>
  //         </Grid>
  //         { !disabled &&
  //           <Grid item>
  //             <Button
  //               variant="contained"
  //               color="primary"
  //               disabled={processing}
  //               onClick={submit}>
  //               Submit
  //             </Button>
  //             <Button
  //               variant="contained"
  //               disabled={processing}
  //               style={{ marginLeft: "4px" }}
  //               onClick={ () => { 
  //                 setNavigateTo(`/dandd/skill`);
  //               }}>
  //               Cancel
  //             </Button>
  //           </Grid>
  //         }
  //       </Grid>
  //     </div>
  //   ); 
  // }
  return <></>
}
